const state = {
  queryResponse: null,
  queryProcess: null,
  tableBusy: false,
  do_queryAgain: false,
  selectOptionQuery: false,
  inputData: {
    options: [],
    selected: "",
    inputtext: "",
    table: "",
  },
  phpfunction: "",
  selectTag_default: {
    startTime: true,
    endTime: true,
    startMinTime: false,
    endMinTime: false,
    process: false,
    actProcess: false,
    htProcess: false,
    inspProcess: false,
    deviceCode: false,
    productCode: false,
    workCode: false,
    changeUserCode: false,
    group: false,
  },
  selectTag: {
    startTime: true,
    endTime: true,
    startMinTime: false,
    endMinTime: false,
    process: false,
    actProcess: false,
    htProcess: false,
    inspProcess: false,
    deviceCode: false,
    productCode: false,
    workCode: false,
    changeUserCode: false,
    group: false,
  },
  selectTagCheck_default: {
    startTime: true,
    endTime: true,
    startMinTime: false,
    endMinTime: false,
    process: true,
    actProcess: true,
    htProcess: false,
    inspProcess: true,
    deviceCode: true,
    productCode: false,
    workCode: false,
    changeUserCode: false,
    group: false,
  },
  selectTagCheck: {
    startTime: true,
    endTime: true,
    startMinTime: false,
    endMinTime: false,
    process: true,
    actProcess: true,
    htProcess: false,
    inspProcess: true,
    deviceCode: true,
    productCode: false,
    workCode: false,
    changeUserCode: false,
    group: false,
  },
  otherData: {},
  processOption: [],
  actProcessOption: [],
  htProcessOption: [],
  inspProcessOption: [],
  orgProcessOption: [],
  deviceOption: {},
  groupOption: {},
  plugInPage: ""
};
const getters = {
  get_queryResponse: state => {
    return state.queryResponse;
  },
  get_queryProcess: state => {
    return state.queryProcess;
  },
  get_tableBusy: state => {
    return state.tableBusy;
  },
  receive_queryAgain: state => {
    return state.do_queryAgain;
  },
  receive_selectOptionQuery: state => {
    return state.selectOptionQuery;
  },
  get_inputData: state => {
    var inputData = {};
    inputData.options = state.inputData.options;
    inputData.selected = state.inputData.selected;
    inputData.inputtext = state.inputData.inputtext;
    inputData.table = state.inputData.table;
    return inputData;
  },
  get_phpfunction: state => {
    return state.phpfunction;
  },
  get_selectTag: state => {
    return state.selectTag;
  },
  get_selectTagCheck: state => {
    return state.selectTagCheck;
  },
  get_processOption: state => {
    return state.processOption;
  },
  get_actProcessOption: state => {
    return state.actProcessOption;
  },
  get_htProcessOption: state => {
    return state.htProcessOption;
  },
  get_inspProcessOption: state => {
    return state.inspProcessOption;
  },
  get_orgProcessOption: state => {
    return state.orgProcessOption;
  },
  get_deviceOption: state => {
    return state.deviceOption;
  },
  get_groupOption: state => {
    return state.groupOption;
  },
  get_otherData: state => {
    return state.otherData;
  },
  get_plugInPage: state => {
    return state.plugInPage;
  }
};
const actions = {
  set_queryResponse(context, data) {
    context.commit("SET_QUERYRESPONSE", data);
  },
  set_queryProcess(context, data) {
    context.commit("SET_QUERYPROCESS", data);
  },
  change_tableBusy(context) {
    context.commit("CHANGE_TABLEBUSY");
  },
  do_queryAgain(context) {
    context.commit("DO_QUERYAGAIN");
  },
  do_selectOptionQuery(context, data) {
    context.commit("DO_SELECTOPTIONQUERY", data);
  },
  set_inputData(context, obj) {
    context.commit("SET_INPUTDATA", obj);
  },
  set_phpfunction(context, data) {
    context.commit("SET_PHPFUNCTION", data);
  },
  set_selectTag(context, data) {
    context.commit("SET_SELECTTAG", data);
  },
  set_selectTagCheck(context, data) {
    context.commit("SET_SELECTTAGCHECK", data);
  },
  set_processOption(context, data) {
    context.commit("SET_PROCESSOPTION", data);
  },
  set_actProcessOption(context, data) {
    context.commit("SET_ACTPROCESSOPTION", data);
  },
  set_htProcessOption(context, data) {
    context.commit("SET_HTPROCESSOPTION", data);
  },
  set_inspProcessOption(context, data) {
    context.commit("SET_INSPPROCESSOPTION", data);
  },
  set_orgProcessOption(context, data) {
    context.commit("SET_ORGPROCESSOPTION", data);
  },
  set_deviceOption(context, data) {
    context.commit("SET_DEVICEOPTION", data);
  },
  set_groupOption(context, data) {
    context.commit("SET_GROUPOPTION", data);
  },
  set_otherData(context, data) {
    context.commit("SET_OTHERDATA", data);
  },
  set_plugInPage(context, data) {
    context.commit("SET_PLUGINPAGE", data);
  }
};
const mutations = {
  SET_QUERYRESPONSE(state, data) {
    state.queryResponse = data;
  },
  SET_QUERYPROCESS(state, data) {
    state.queryProcess = data;
  },
  CHANGE_TABLEBUSY(state) {
    state.tableBusy = !state.tableBusy;
  },
  DO_QUERYAGAIN(state) {
    state.do_queryAgain = !state.do_queryAgain;
  },
  DO_SELECTOPTIONQUERY(state, data) {
    state.selectOptionQuery = data;
  },
  SET_INPUTDATA(state, obj) {
    state.inputData.options = obj.options;
    state.inputData.selected = obj.selected;
    state.inputData.inputtext = obj.inputtext;
    state.inputData.table = obj.table;
  },
  SET_PHPFUNCTION(state, data) {
    state.phpfunction = data;
  },
  SET_SELECTTAG(state, obj) {
    let obj_key = Object.keys(obj);
    let selectTag_default = state.selectTag_default;
    let selectTag_default_key = Object.keys(selectTag_default);
    let selectTag = {};
    for (let i = 0; i < selectTag_default_key.length; i++) {
      if (obj_key.indexOf(selectTag_default_key[i]) != -1) {
        selectTag[selectTag_default_key[i]] = obj[selectTag_default_key[i]]
      } else {
        selectTag[selectTag_default_key[i]] = selectTag_default[selectTag_default_key[i]]
      }
    }
    state.selectTag = selectTag;
  },
  SET_PROCESSOPTION(state, array) {
    state.processOption = array;
  },
  SET_ACTPROCESSOPTION(state, array) {
    state.actProcessOption = array;
  },
  SET_HTPROCESSOPTION(state, array) {
    state.htProcessOption = array;
  },
  SET_INSPPROCESSOPTION(state, array) {
    state.inspProcessOption = array;console.log(array);
  },
  SET_ORGPROCESSOPTION(state, array) {
    state.orgProcessOption = array;
  },
  SET_DEVICEOPTION(state, obj) {
    state.deviceOption = obj;
  },
  SET_GROUPOPTION(state, obj) {
    state.groupOption = obj;
  },
  SET_OTHERDATA(state, data) {
    state.otherData = data;
  },
  SET_PLUGINPAGE(state, data) {
    state.plugInPage = data;
  },
  SET_SELECTTAGCHECK(state, obj) {
    let obj_key = Object.keys(obj);
    let selectTagCheck_default = state.selectTagCheck_default;
    let selectTagCheck_default_key = Object.keys(selectTagCheck_default);
    let selectTagCheck = {};
    for (let i = 0; i < selectTagCheck_default_key.length; i++) {
      if (obj_key.indexOf(selectTagCheck_default_key[i]) != -1) {
        selectTagCheck[selectTagCheck_default_key[i]] = obj[selectTagCheck_default_key[i]]
      } else {
        selectTagCheck[selectTagCheck_default_key[i]] = selectTagCheck_default[selectTagCheck_default_key[i]]
      }
    }
    state.selectTagCheck = selectTagCheck;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/commonQueryIoT.js